import React, { createContext, useState, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';
import { supabase } from '../supabase';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

    useEffect(() => {
      const { data: authListener } = supabase.auth.onAuthStateChange(async (event, session) => {
        if (session) {
          try {
            axios.defaults.headers.common['Authorization'] = `Bearer ${session.access_token}`;
            
            // Fetch user data from backend (Supabase 'users' table)
            const res = await axios.get('/api/auth/me'); // Call the backend /api/auth/me endpoint
            setUser(res.data.user);
          } catch (error) {
            console.error('Error fetching user data from backend:', error);
            setUser(null);
          }
        } else {
          delete axios.defaults.headers.common['Authorization'];
          setUser(null);
        }
        setLoading(false);
      });
  
      return () => {
        authListener.subscription.unsubscribe();
      };
    }, []);
    const login = useCallback(async (email, password) => {
      try {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  
        if (error) {
          return {
            success: false,
            message: error.message || 'Login failed'
          };
        }
  
        const { session } = data;
        axios.defaults.headers.common['Authorization'] = `Bearer ${session.access_token}`;
  
        // Get user data from backend
        const res = await axios.get('/api/auth/me'); // Call the backend /api/auth/me endpoint
        setUser(res.data.user);
  
        return { success: true };
      } catch (error) {
        return {
          success: false,
          message: error.message || 'Login failed'
        };
      }
    }, []);
    const register = useCallback(async (name, email, password) => {
      try {
        // Register with backend (creates Supabase user + profile)
        const res = await axios.post('/api/auth/register', { name, email, password });
  
        const { token, user } = res.data;
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  
        setUser(user);
  
        return { success: true };
      } catch (error) {
        return {
          success: false,
          message: error.response?.data?.message || error.message || 'Registration failed'
        };
      }
    }, []);
  const logout = useCallback(async () => {
    try {
      await supabase.auth.signOut();
      delete axios.defaults.headers.common['Authorization'];
      setUser(null);
    } catch (error) {
      console.error('Logout error:', error);
    }
  }, []);

  const value = useMemo(() => ({
    user,
    loading,
    login,
    register,
    logout
  }), [user, loading, login, register, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
